import { render } from "./PostKillmail.vue?vue&type=template&id=b3099c3a"
import script from "./PostKillmail.vue?vue&type=script&lang=js"
export * from "./PostKillmail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\justi\\Code\\vuekillmailtool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__